import { render, staticRenderFns } from "./Header2.vue?vue&type=template&id=2658ee05&scoped=true"
import script from "./Header2.vue?vue&type=script&lang=ts"
export * from "./Header2.vue?vue&type=script&lang=ts"
import style0 from "./Header2.vue?vue&type=style&index=0&id=2658ee05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2658ee05",
  null
  
)

export default component.exports